export default __webpack_public_path__ + "static/media/blog-banner.b6f58bb1.svg";